


import React, { useState, useEffect } from "react";
import "../assets/Loan/LoanKyc.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoanDetails } from "../redux/slices/loan/loanKycSlice";
import { toast } from "react-toastify";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { fetchDocuments } from "../redux/slices/kycuploadslice"; // <-- import your slice



export default function BranchLoanDetail() {
  const dispatch = useDispatch();

  const loanState = useSelector((state) => state.loanKyc || {});
  const loanDetail = loanState.loanDetail || null;
  const loading = loanState.loading;
  const error = loanState.error;

  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const [docType, setDocType] = useState("");
  const [docFile, setDocFile] = useState(null);
  const [uploadedKyc, setUploadedKyc] = useState([]);
  const { profile, loading: profileLoading,  } = useSelector(
      (state) => state.userProfile
    );

        const { documents,  } = useSelector((state) => state.documents);
    
     useEffect(() => {
      if (profile && profile.superAdminId) {
        dispatch(fetchDocuments({ serviceId: profile.superAdminId, description: "Loan" }));
      }
    }, [dispatch, profile]);
    
  

      // Fetch profile
      useEffect(() => {
        dispatch(fetchUserProfile());
      }, [dispatch]);
    

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  useEffect(() => {
    if (loanDetail?.loanAccountNumber) {
      fetchUploadedKyc(loanDetail?.loanAccountNumber);
    }
  }, [loanDetail]);

  

const handleDeleteKyc = async (docId) => {
  if (!window.confirm("Are you sure you want to delete this document?")) return;

  try {
    const response = await fetch(`https://narrowitsolution.in/api/delete-new-loan-kyc/${docId}`, {
      method: "DELETE",
    });
    const result = await response.json();

    if (response.ok) {
      toast.success("Document deleted successfully!");
      // Refresh the KYC list
      if (loanDetail?.loanAccountNumber) {
        fetchUploadedKyc(loanDetail.loanAccountNumber);
      }
    } else {
      toast.error(result.message || "Failed to delete document.");
    }
  } catch (err) {
    toast.error("Error deleting document.");
    console.error(err);
  }
};


  const handleFilterSearch = () => {
  if (!filterType || !filterValue.trim()) {
    toast.warning("Please select filter type and provide value.");
    return;
  }

  const filters = {};
  if (filterType === "loanAccountNumber") filters.loanAccountNumber = filterValue.trim();
  else filters.userId = filterValue.trim();

  dispatch(fetchLoanDetails(filters))
    .unwrap()
    .then((loan) => {
      toast.success("Loan details fetched successfully!");
      if (loan?.loanAccountNumber) {
        fetchUploadedKyc(loan.loanAccountNumber);
      } else {
        setUploadedKyc([]);  // No documents if no customerId
      }
    })
    .catch((err) => toast.error(err));
};



  const fetchUploadedKyc = async (loanAccountNumber) => {
    try {
      const response = await fetch(
        `https://narrowitsolution.in/api/get-new-loan-kyc?accountNumber=${loanAccountNumber}`
      );
      const result = await response.json();
      if (response.ok) {
        setUploadedKyc(result.documents);
      } else {
        toast.error("Failed to fetch uploaded documents.");
      }
    } catch (err) {
      toast.error("Error fetching uploaded documents.");
      console.error(err);
    }
  };



  const handleUpload = async () => {
    if (!docType || !docFile) {
      toast.warning("Please select document type and file.");
      return;
    }

    const formData = new FormData();
    formData.append("docName", docType);
    formData.append("file", docFile);
    formData.append("branchId", 1); // Example value
    formData.append("customerId", loanDetail.customerId);
    formData.append("customerName", loanDetail.userName);
    formData.append("loanId", loanDetail.id);
    formData.append("accountNumber", loanDetail.loanAccountNumber);
    formData.append("status", "Pending");
    formData.append("createdId", localStorage.getItem("userId"));      // Example value
    formData.append("createdName", "Admin"); // Example value
    formData.append("superAdminId", 1);    // Example value

    try {
      const response = await fetch('https://narrowitsolution.in/api/upload-new-loan-kyc', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("KYC Document uploaded successfully!");
          fetchUploadedKyc(loanDetail.loanAccountNumber); // refresh list
  setDocType("");
  setDocFile(null);

      } else {
        toast.error(result.message || "Upload failed!");
      }
    } catch (err) {
      toast.error("Error uploading document.");
      console.error(err);
    }
  };

  return (
    <div className="BranchLoanKycUpload-container">

      <h1>Branch Loan Details</h1>

      {/* 1. Filter Loan */}
      <section className="BranchLoanKycUpload-section">
        <h2>1. Filter Loan</h2>
        <div className="BranchLoanKycUpload-filter-row">
          <select
            value={filterType}
            onChange={(e) => { setFilterType(e.target.value); setFilterValue(""); }}
          >
            <option value="">Select Filter Type</option>
            {/* <option value="userId">User ID</option> */}
            <option value="loanAccountNumber">Loan Account Number</option>
          </select>

          <input
            type="text"
            placeholder={`Enter ${filterType}`}
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
          />

          <button type="button" onClick={handleFilterSearch}>Search</button>
        </div>
      </section>

      {/* 2. Loader */}
      {loading && <p>Loading...</p>}

      {/* 3. Loan Details */}
      {loanDetail ? (
        <section className="BranchLoanKycUpload-section">
          <h2>2. Loan Details</h2>
          <div className="table-wrapper">
            <table className="BranchLoanKycUpload-user-details-table">
              <tbody>
                <tr><th>Customer Name</th><td>{loanDetail.userName}</td></tr>
                <tr><th>Customer Id</th><td>{loanDetail.customerId}</td></tr>
                <tr><th>Loan Account</th><td>{loanDetail.loanAccountNumber}</td></tr>
                <tr><th>Loan Type</th><td>{loanDetail.loanType}</td></tr>
                <tr><th>Loan Amount</th><td>{loanDetail.loanAmount}</td></tr>
                <tr><th>Loan Tenure</th><td>{loanDetail.loanTenure} {loanDetail.tenuretype}</td></tr>
                <tr><th>ROI</th><td>{loanDetail.loanRoi} %</td></tr>
                {/* <tr><th>EMI Amount</th><td>{loanDetail.loanEmiAmount}</td></tr> */}
                <tr><th>Loan Status</th><td>{loanDetail.status}</td></tr>
                {/* <tr><th>KYC Status</th><td>{loanDetail.kycStatus}</td></tr> */}
                {/* <tr><th>Disbursal Date</th><td>{new Date(loanDetail.disbursalDate).toLocaleDateString()}</td></tr> */}
                {/* <tr><th>Collection Landmark</th><td>{loanDetail.collectionLandmark}</td></tr> */}
              </tbody>
            </table>
          </div>
        </section>
      ) : !loading ? (
        <p>No loan details found.</p>
      ) : null}

      {/* 4. Upload KYC Document */}
      <section className="BranchLoanKycUpload-section">
        <h2>3. Upload KYC Document</h2>
        <div className="BranchLoanKycUpload-upload-row">
          <select value={docType} onChange={(e) => setDocType(e.target.value)}>
              <option value="">Choose Document Type</option>
             {documents.map((doc, idx) => (
    <option key={idx} value={doc.name}>
      {doc.name}
    </option>
  ))}
          </select>

          {docType && (
            <>
              <input
                type="file"
                onChange={(e) => e.target.files && setDocFile(e.target.files[0])}
              />
              {docFile && <span>{docFile.name}</span>}
            </>
          )}

          <button onClick={handleUpload}>Upload</button>
        </div>
      </section>

      {/* 5. Loan KYC Document List */}
      {/* <section className="BranchLoanKycUpload-section">
        <h2>4. Loan KYC Document Details</h2>
        <div className="table-wrapper">
          <table className="BranchLoanKycUpload-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Document Name</th>
                <th>Status</th>
                <th>Preview</th>
              </tr>
            </thead>
            <tbody>
              {uploadedKyc.length > 0 ? (
                uploadedKyc.map((doc, idx) => (
                  <tr key={doc.id}>
                    <td>{idx + 1}</td>
                    <td>{doc.docName}</td>
                    <td>{doc.status}</td>
                    <td>
                      {doc.docImage ? (
                        <a
                          href={`https://narrowitsolution.in/uploads/${doc.docImage}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Preview
                        </a>
                      ) : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    {loanDetail ? "No documents found." : "Please search a loan first."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section> */}
      <section className="BranchLoanKycUpload-section">
  <h2>4. Loan KYC Document Details</h2>
  <div className="table-wrapper">
    <table className="BranchLoanKycUpload-table">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Document Name</th>
          <th>Status</th>
          <th>Preview</th>
          <th>Action</th> {/* New column */}
        </tr>
      </thead>
      <tbody>
        {uploadedKyc.length > 0 ? (
          uploadedKyc.map((doc, idx) => (
            <tr key={doc.id}>
              <td>{idx + 1}</td>
              <td>{doc.docName}</td>
              <td>{doc.status}</td>
              <td>
                {doc.docImage ? (
                  <a
                    href={`https://narrowitsolution.in/uploads/${doc.docImage}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Preview
                  </a>
                ) : "N/A"}
              </td>
              <td>
                <button
                  className="delete-btn"
                  onClick={() => handleDeleteKyc(doc.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5" style={{ textAlign: "center" }}>
              {loanDetail ? "No documents found." : "Please search a loan first."}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</section>


    </div>
  );
}
